import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import meta from '../../config/meta';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import BorderBox from '../blocks/BorderBox.jsx';
import ReadingListItems from '../blocks/ReadingListItems.jsx';
import { subjects } from '../../config/subjects';
import { env } from '../../config';

const PageReadingHistory = () => {
  const [selectedCategory, setSelectedCategory] = useState('geography');
  const [res, req] = useHttpStatus();

  meta.set({ title: '閱讀歷史' });

  // Only subject categories, no "all articles", "text", "video"
  const categories = [
    { key: 'geography', name: subjects.geography.zhhk },
    { key: 'society', name: subjects.society.zhhk },
    { key: 'economicDevelop', name: subjects.economicDevelop.zhhk },
    { key: 'technological', name: subjects.technological.zhhk },
  ];

  const fetchAnswers = () => {
    // Simple approach: get all user's answers and filter client-side
    req({
      url: `/api/quiz/answers/reading-history/${selectedCategory}`,
    });
  };
  const handleDownload = () => {
    const { certSetting: { readingMaterialPDFURL } } = env;
    if (readingMaterialPDFURL) {
      const downloadUrl = readingMaterialPDFURL.startsWith('http')
        ? readingMaterialPDFURL
        : `${process.env.ROOT || window.location.origin}${readingMaterialPDFURL.startsWith('/') ? '' : '/'}${readingMaterialPDFURL}`;

      window.open(downloadUrl, '_blank');
    }
  };

  useEffect(() => {
    fetchAnswers();
  }, [selectedCategory]);

  return (
    <div>
      <header
        className="missions-header d-flex position-relative justify-content-center align-items-center"
        style={{
          height: '180px',
          background: 'linear-gradient(180deg, #4EB2FF 0%, #169CFD 100%)',
        }}
      >
        <img className="left" src="/assets/img/mission-reading-header-left.png"/>
        <img className="right" src="/assets/img/mission-reading-header-right.png"/>
        <div className="container-fluid overflow-hidden">
          <div className="row justify-content-center align-items-center">
            <div className="col text-left">
              <div className="row justify-content-center align-items-end">
                <div className="col d-none d-md-flex justify-content-center">
                  <img src="/assets/img/boy.png" className="px-2 pb-3" height="149"/>
                  <img src="/assets/img/girl.png" className="px-2 pt-3" height="148"/>
                </div>
              </div>
            </div>
            <div className="col col-auto">
              <div className="missions-banner-title-box">
                <img className="left" src="/assets/img/lam.png"/>
                閱讀材料
                <img className="right" src="/assets/img/lam.png"/>
              </div>
            </div>
            {/* <div className="col text-right position-relative">
              {env?.certSetting?.readingMaterialPDFURL && (
                <button
                  className="missions-banner-back-box btn btn-link mx-3"
                  onClick={handleDownload}
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  下載
                </button>
              )}
            </div> */}
            <div className="col">

            </div>
          </div>
        </div>
      </header>

      <div className="container-fluid no-gutters px-0">
        <div className="missions-bar position-absolute"></div>

        {/* Mission Bar for Categories - Similar to MissionBar component */}
        <div className="missions-bar-container">
          <div className="missions-bar row mx-0 p-1">
            {categories.map((category) => (
              <div
                key={category.key}
                className="col-6 col-md-auto p-1 mx-0 mx-md-2 mission-item"
              >
                <div
                  className={`mission-item ${selectedCategory === category.key ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.key)}
                  style={{ cursor: 'pointer' }}
                >
                  {category.name}
                </div>
              </div>
            ))}
          </div>
        </div>
        <BorderBox
          name="missions-box"
          left={{
            width: '45px',
            background: 'linear-gradient(180deg, #B1EAFF 0%, #78DBFF 100%)',
          }}
          right={{
            width: '45px',
            background: 'linear-gradient(180deg, #15C1FF 0%, #A8E2F7 100%)',
          }}
          top={{ height: '53px' }}
          bottom={{ height: '53px' }}
        >
          <PageHttp res={res} className="position-relative">
            {(rows) => (
                <ReadingListItems
                  articles={rows}
                />
            )}
          </PageHttp>
        </BorderBox>
      </div>
    </div>
  );
};

export default PageReadingHistory;
